<template>
	<div class="deal_box">
		<!-- 分割线 -->
		<div class="cut_off"></div>
		<!-- 内容 -->
		<div class="deal_show_box">
			<!-- 左边 deal_left -->
			<div class="deal_left">
				<!-- 用户头像区块 -->
				<div class="deal_user">
					<div class="deal_user_photo">
						<img src="../../../assets/img/common/photo_replace.png" alt="">
					</div>
					<div class="deal_user_name">{{this.$store.state.storename}}</div>
					<div class="deal_user_id">UID：{{this.$store.state.uid}}</div>
					<!-- deal_user -->
				</div>
				<!-- 下拉菜单 -->
				<div class="drop_down_box">
					<!-- 個人設定 -->
					<div class="drop_box drop_management" :class="showst==1?'drop_active':''"  @click="downShows(1)">
						<div class="drop_down_title drop_down_hehi" >
							<img src="../../../assets/img/user/service_center_board1.png" alt="">個人設定<i :class="showst==1?'el-icon-arrow-up':'el-icon-arrow-down'" ></i>
						</div>
						<ul class="drop_down_content" v-show="showst==1">
							<li :class="lilist=='1-1'?'active':''"  @click="activeFun('1-1','')">· 個人資訊</li>
							<li :class="lilist=='1-2'?'active':''" @click="activeFun('1-2','bindings')">· 安全綁定</li>
						</ul>
					</div>
					<!-- 帳戶設定 -->
					<div class="drop_box drop_settlement" :class="showst==2?'drop_active':''"  @click="downShows(2)">
						<div class="drop_down_title">
							<img src="../../../assets/img/user/service_center_board2.png" alt="">帳戶設定<i :class="showst==2?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
						</div>
						<ul class="drop_down_content" v-show="showst==2">
							<li :class="lilist=='2-1'?'active':''" @click="activeFun('2-1','loginbu')">· 商家資訊</li>
							<li :class="lilist=='2-2'?'active':''" @click="activeFun('2-2','loginbbill')">· 發票資訊</li>
							<li :class="lilist=='2-3'?'active':''" @click="activeFun('2-3','loginbapi')">· API安全</li>
							<!-- <li :class="lilist=='2-4'?'active':''" @click="activeFun('2-4','loginbjtion')">· 權限設定</li>
							<li :class="lilist=='2-5'?'active':''" @click="activeFun('2-5','loginbuaccount')">· 員工帳戶管理</li> -->
						</ul>
					</div>
					<!-- 安全中心 -->
					<div class="drop_box drop_bill">
						<div class="drop_down_title deoset_left"  @click="goLoginat('loginsafe')">
							<img src="../../../assets/img/user/service_center_board3.png" alt="" >安全中心
						</div>
					</div>
					<!-- 消費者投訴 -->
					<div class="drop_box drop_fund">
						<div class="drop_down_title deoset_left_onr" @click="goLoginat('logincomplaints')">
							<img src="../../../assets/img/user/service_center_board4.png" alt="">消費者投訴
						</div>
					</div>
					<!-- 違規記錄 -->
					<div class="drop_box drop_voucher" >
						<div class="drop_down_title deoset_left" @click="goLoginat('loginviolation')">
							<img src="../../../assets/img/user/service_center_board5.png" alt="">違規記錄
						</div>
					</div>
					<!-- 安全中心 -->
					<div class="drop_box drop_bill" :class="showst==3?'drop_active':''" @click="downShows(3)">
						<div class="drop_down_title" >
							<img src="../../../assets/img/user/service_center_board6.png" alt="">聯絡客服<i :class="showst==3?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
						</div>
						<ul class="drop_down_content" v-show="showst==3">
							<li :class="lilist=='3-1'?'active':''" @click="activeFun('3-1','loginonline')" >· 申訴留言</li>
							<li :class="lilist=='3-2'?'active':''" @click="activeFun('3-2','logincustomer')">· 線上客服</li>
						</ul>
					</div>
					<!-- drop_down_box -->
				</div>
				<!-- deal_left -->
			</div>
			<!-- 右边区块 -->
			<div class="deal_right">
				<router-view></router-view>
			</div>
			<!-- 内容 -->
		</div>
		<!-- deal_box -->
	</div>
</template>

<script>
	export default {
		name: 'platform',
		props: {},
		data() {
			return {
				userName: "這裡是商家簡稱",
				userId: 87775476,
				showst: sessionStorage.dropActive || 1,
				lilist: sessionStorage.numberactive || '1-1',
				
			}
		},
		components: {

		},
	

		methods: {
			downShows(index){
				this.showst=index;
      			sessionStorage.dropActive = index;
			},
			goLoginat(url) {
			    this.$router.push('/login/account/'+url)
			},
			activeFun(index, url){
				this.lilist = index;
				sessionStorage.numberactive = index;
				this.$router.push('/login/account/'+url);
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	/*  */
	.deal_box {
		background: #f3f3f3;
		overflow: hidden;
	}

	.cut_off {
		height: 4px;
		background: #e73262;
	}

	/*  */
	.deal_show_box {
		display: flex;

	}

	/* left */
	 .deal_left {
	  width: 220px;
	  min-width: 220px;
	  min-height: 700px;
	  background: #393857;
	  font-size: 13px;
	  color: #ffffff;
	}
	.deal_user {
	  box-sizing: border-box;
	  height: 264px;
	  font-size: 13px;
	  letter-spacing: 1px;
	  display: flex;
	  flex-direction: column;
	  align-items: center;
	  padding: 30px 0;
	}

	.deal_user .deal_user_photo {
		width: 140px;
		height: 140px;
		background: url("../../../assets/img/common/user_photo.png") center no-repeat;
		background-size: contain;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 0 auto;
	}

	.deal_user .deal_user_photo img {
		width: 25px;
		height: 25px;
	}

	.deal_user .deal_user_name {
		font-size: 15px;
		margin-top: 24px;
		margin-bottom: 10px;
	}

	/* 下拉菜单 */
	.drop_box {
		/* background: #30304c; */
		text-align: center;
		overflow: hidden;
		box-sizing: border-box;
	}

	.drop_active {
		background: #30304c;
	}

	.drop_down_title {
		cursor: pointer;
		box-sizing: border-box;
		font-size: 15px;
		margin-top: 15px;
	}

	.drop_down_hehi {
		margin-bottom: 0px;
	}

	.drop_down_title img {
		box-sizing: border-box;
		width: 35px;
		height: 35px;
		margin-right: 10px;
	}

	.drop_down_title i {
		box-sizing: border-box;
		text-align: center;
		margin-left: 40px;

	}

	.drop_down_content li {
		text-align: left;
		margin-left: 71px;
		font-size: 13px;
		padding: 8px 0;
		cursor: pointer;
	}

	.drop_down_content {
		padding-bottom: 8px;
	}

	.drop_down_content .active {
		border-right: 6px solid #e73262;
		color: #e73262;
		box-sizing: border-box;
	}

	.drop_down_content .last {
		margin-bottom: 8px;
	}

	/* right */
	.deal_right {
		width: 84.5vw;
	}

	/* 無下拉按鈕填充 */
	.deoset_left {
		padding-right: 55px;
	}

	.deoset_left_onr {
		padding-right: 45px;
	}
</style>
